module.exports = __webpack_public_path__ + "img/layout-3.fdd0efd5.jpg";